import { useState, useEffect } from 'react';
import AdminSidebar from '../../components/adminSidebar/adminSidebar';
import AdminBanners from '../../components/adminSidebar/adminbanners';
import Get_Workers from '../../components/adminSidebar/adminWorkers';
import Get_Companies from '../../components/adminSidebar/adminEmployers';
import AdminTexts from '../../components/adminSidebar/admintexts';
import Get_Vacancies from '../../components/adminSidebar/adminwacancies';
import BlogsTable from '../../components/adminSidebar/adminblogs';

// SVG иконки
const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Состояние загрузки
  const [activePage, setActivePage] = useState("home");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Проверяем localStorage при монтировании
  useEffect(() => {
    const auth = localStorage.getItem('adminAuth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // НАСТРОЙКА: Укажите здесь правильный путь к вашему PHP файлу
      const response = await fetch('/api/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password: password }),
      });

      const data = await response.json();

      if (data.success) {
        setIsAuthenticated(true);
        localStorage.setItem('adminAuth', 'true');
        setPassword('');
      } else {
        // Выводим ошибку, пришедшую от PHP (например, "Սխալ գաղտնաբառ")
        setError(data.message || 'Մուտքի սխալ');
        setPassword('');
      }
    } catch (err) {
      setError('Կապի սխալ սերվերի հետ:');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('adminAuth');
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    setSidebarOpen(false);
  };

  if (!isAuthenticated) {
    return (
      <section className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
        <div className="max-w-md w-full">
          <form className="w-full max-w-[500px] mx-auto rounded-xl bg-white p-6 space-y-6" onSubmit={handleLogin}>
            <h2 className="mt-6 text-center text-2xl sm:text-3xl font-extrabold text-[#006674]">
              Ադմին Հարթակ Մուտք
            </h2>

            <div>
              <input
                type="password"
                required
                disabled={isLoading}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#006674] focus:border-transparent disabled:bg-gray-100"
                placeholder="Մուտքագրեք գաղտնաբառը"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && <div className="text-red-500 text-sm text-center">{error}</div>}

            <button 
              disabled={isLoading}
              className="w-full py-2 px-4 rounded-md text-white bg-[#006674] hover:bg-[#005561] transition-colors disabled:bg-gray-400"
            >
              {isLoading ? 'Ստուգվում է...' : 'Մուտք'}
            </button>
          </form>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full min-h-screen bg-gray-900">
      <header className="bg-gray-800 text-white p-4 w-full">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden text-white hover:text-[#006674] transition-colors"
              aria-label="Открыть меню"
            >
              <MenuIcon />
            </button>
            <h1 className="text-lg sm:text-xl font-bold">Ադմին Հարթակ</h1>
          </div>
          <button
            onClick={handleLogout}
            className="bg-red-500 hover:bg-red-600 px-3 py-1.5 sm:px-4 sm:py-2 rounded text-sm sm:text-base transition-colors"
          >
            Դուրս գալ
          </button>
        </div>
      </header>

      <main className="flex relative">
        <div className="hidden lg:block">
          <AdminSidebar setActivePage={setActivePage} activePage={activePage} />
        </div>

        {sidebarOpen && (
          <div className="fixed inset-0 z-50 lg:hidden">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setSidebarOpen(false)} />
            <div className="absolute left-0 top-0 h-full w-64 bg-gray-800 shadow-xl z-10">
              <div className="flex justify-end p-4">
                <button
                  onClick={() => setSidebarOpen(false)}
                  className="text-white hover:text-[#006674] transition-colors"
                  aria-label="Закрыть меню"
                >
                  <CloseIcon />
                </button>
              </div>
              <AdminSidebar setActivePage={handlePageChange} activePage={activePage} />
            </div>
          </div>
        )}

        <section className="flex-1 p-4 sm:p-6">
          {activePage === "home" && (
            <h1 className="text-2xl sm:text-3xl md:text-4xl text-center mt-8 sm:mt-16 text-white">
              Բարի գալուստ Ադմին Հարթակ
            </h1>
          )}

          {activePage === "banners" && <AdminBanners />}
          {activePage === "moderation" && <h1 className="text-2xl sm:text-4xl font-bold text-white">Մոդերացիա</h1>}
          {activePage === "candidates" && <Get_Workers />}
          {activePage === "companies" && <Get_Companies />}
          {activePage === "vacancies" && <Get_Vacancies />}
          {activePage === "Blogs" && <BlogsTable />}
          {activePage === "packages" && <h1 className="text-2xl sm:text-4xl font-bold text-white">Փաթեթներ գործատուների</h1>}
          {activePage === "notifications" && <h1 className="text-2xl sm:text-4xl font-bold text-white">Ծանուցումներ</h1>}
          {activePage === "mails" && <h1 className="text-2xl sm:text-4xl font-bold text-white">Mail նամակներ</h1>}
          {activePage === "texts" && <AdminTexts />}
        </section>
      </main>
    </section>
  );
};

export default AdminPage;